/**
 * @file divider component
 *
 * @author seedlessapple <luminousseedlessapple@gmail.com>
 *
 * -------------------------------------------------------
 *
 * IN PRODUCTION
 * - divider component
 *
 * -------------------------------------------------------
 *
 * IN MAINTENANCE
 *
 * -------------------------------------------------------
 *
 * IN DEVELOPMENT
 *
 * -------------------------------------------------------
 *
 * DEPRECATED
 *
 * -------------------------------------------------------
 *
 * NOTES
 *
 */

/**
 * divider component
 *
 * @returns divider component
 * 
 * @version 1.0 initial version
 */
const Divider = () => {
  return (
    <div
      style={{
        width: "100%",
        borderBottom: "var(--border-default)",
        margin: "12px 0",
      }}
    ></div>
  );
};

export default Divider;
